import { useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/ApiUrl";
import axios from "axios";
import CustomToast from '../../components/CustomToast';


function useDisputeSubmit(setFilePreview,
    setFile,file, taskData, message, id, setLoader, fetchTaskData, handleClose2, handleShow5) {

    // Updated imgeUrl function to return the URL
    const imgeUrl = async (e) => {
        // // console.log(e, 'e');
        let accessToken = localStorage.getItem("accessToken");

        // Create a FormData object to send the image
        let formData = new FormData();
        formData.append("image", e); // Assuming 'e' is the image file

        const config = {
            method: "post",
            url: `${API_URL}metadata/upload-image`,
            headers: {
                "Content-Type": "multipart/form-data", // Correct content type for file uploads
                Authorization: `Bearer ${accessToken}`,
            },
            data: formData, // Send formData with the image file
        };

        try {
            let response = await axios(config);
            if (response) {
                // // console.log(response.data.url, 'response');
                return response.data.url; // Return the URL for further processing
            }
        } catch (error) {
            // Extract the error message from the API response and return it
            if (error.response) {
                const apiErrorMessage =
                    error.response.data.message || error.response.data;
                console.error("API Error:", apiErrorMessage);
                return { error: apiErrorMessage }; // Return an object containing the error message
            } else {
                console.error("Error occurred while uploading image:", error);
                return {
                    error: "An unknown error occurred while uploading the image.",
                }; // Return a default error message
            }
        }
    };
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            // Extract the file extension by splitting on the last period
            const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

            // Define allowed extensions dynamically based on deliveryFormat
            const updatedDeliveryFormats = [
                ...["jpg", "jpeg", "png", "webp"],
                ...(taskData?.deliveryFormat || []), // Preserve existing deliveryFormat values
            ];

            const allowedExtensions =
                updatedDeliveryFormats?.length > 0
                    ? updatedDeliveryFormats?.map((format) => format.toLowerCase())
                    : null; // If no specific formats are defined, allow all formats

            // console.log("Allowed Extensions:", allowedExtensions); // Debugging line
            // console.log("Selected File Extension:", fileExtension); // Debugging line

            // Allow the file if no specific formats are defined or if the file extension matches one of the allowedExtensions
            if (!allowedExtensions || allowedExtensions.includes(fileExtension)) {
                setFile(selectedFile);
                setFilePreview(URL.createObjectURL(selectedFile)); // Create a URL for the file preview
                // console.log("File accepted"); // Debugging line
            } else {
                // toast.error("Unsupported file type. Please upload a valid file.");
                 CustomToast.show('error', 'Error!', 'Unsupported file type. Please upload a valid file.')

                // console.log("Unsupported file type"); // Debugging line
            }
        }
    };
    const handleSubmitDispute = async () => {
        if (!file || !message) {
            // toast.warn("Please fill in the message and select a file.");
            CustomToast.show('warning', 'Warning!', 'Please fill in the message and select a file.')





            return;
        }
        let accessToken = localStorage.getItem("accessToken");
        setLoader(true);
        // Step 1: Upload the file to get the URL or an error
        let uploadedImageResponse = await imgeUrl(file); // Call the function to upload the image and get the URL or error

        // Step 2: Check if the response contains an error
        if (uploadedImageResponse && uploadedImageResponse.error) {
            // toast.error(`Failed to upload the file: ${uploadedImageResponse.error}`);
            CustomToast.show('error', 'Error!', 'Failed to upload the file: '+ uploadedImageResponse.error)
            setLoader(false);
            return;
        }

        // If no error, get the uploaded image URL
        let uploadedImageUrl = uploadedImageResponse;

        // Step 3: Prepare data for the PATCH request
        const dataToSubmit = {
            message: message, // Replace with the actual unique code if it's dynamic
            proofOfWork: [uploadedImageUrl], // Add the uploaded image URL to this array
        };

        try {
            // Replace 'your-api-endpoint' with the actual endpoint
            await axios.post(`${API_URL}tasks/${id}/dispute`, dataToSubmit, {
                headers: {
                    "Content-Type": "application/json", // Use application/json since we are sending a JSON object
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            fetchTaskData()
            // toast.success('File submitted successfully!');
            handleClose2(); // Close modal after successful submission
            handleShow5();
            setLoader(false);
        } catch (error) {
            // Log detailed error response if available
            if (error.response) {
                console.error(
                    "API Error:",
                    error.response.data.message || error.response.data
                );
                setLoader(false);
                // toast.error(
                //     `Error submitting task: ${error.response.data.message || "Unknown error"
                //     }`
                // );
                CustomToast.show('error', 'Error!', 'Error submitting task: '+ error.response.data.message)
            } else {
                console.error("Error submitting the task:", error);
                setLoader(false);
                // toast.error("Failed to submit the task. Please try again.");
                CustomToast.show('error', 'Error!', 'Failed to submit the task. Please try again.')
            }
        }
    };
    return {  handleSubmitDispute, handleFileChange }
}
export default useDisputeSubmit;